"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultParams = void 0;
// eslint-disable-next-line import/prefer-default-export
var getDefaultParams = function () {
    var _a;
    var baseUrl = "";
    var radFastLaneUrl = "";
    var sessionIdKey = "";
    var appId = "";
    var fixedformUrl = "";
    var pathwayNavigatorUrl = "";
    var educatorUserUrl = "";
    if (window.STUDENT_ENV !== undefined) {
        baseUrl = window.STUDENT_ENV.REACT_APP_MPNG_API_BASE_URL;
        radFastLaneUrl = window.STUDENT_ENV.REACT_APP_RAD_FASTLANE_API_URL;
        sessionIdKey = window.STUDENT_ENV.REACT_APP_SESSION_KEYNAME || "sessionId";
        appId = window.STUDENT_ENV.REACT_APP_APPLICATION_ID;
        fixedformUrl = window.STUDENT_ENV.REACT_APP_FIXEDFORM_API_URL;
        pathwayNavigatorUrl = window.STUDENT_ENV.REACT_APP_PATHWAY_NAVIGATOR_URL;
        educatorUserUrl = window.STUDENT_ENV.REACT_APP_EDUCATOR_USER_API_URL;
    }
    else if (window.EDUCATOR_ENV !== undefined) {
        baseUrl = window.EDUCATOR_ENV.REACT_APP_MPNG_API_BASE_URL;
        radFastLaneUrl = window.EDUCATOR_ENV.REACT_APP_RAD_FASTLANE_API_URL;
        sessionIdKey = window.EDUCATOR_ENV.REACT_APP_SESSION_KEYNAME || "sessionId";
        appId = window.EDUCATOR_ENV.REACT_APP_APPLICATION_ID;
    }
    var sessionId = sessionStorage.getItem(sessionIdKey);
    var appIdParam = appId ? "?applicationId=".concat(appId) : "";
    var sessionIdParam = sessionId ? "".concat(appIdParam ? "&" : "?", "sessionId=").concat(sessionId) : "";
    var imlpToken = sessionStorage.getItem("imlpToken");
    var isFromAssignment = ((_a = sessionStorage.getItem("launch")) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "assignment";
    var assignmentParam = isFromAssignment ? "&isFromAssignment=".concat(isFromAssignment) : "";
    return {
        baseUrl: baseUrl,
        defaultParams: "".concat(appIdParam).concat(sessionIdParam).concat(assignmentParam),
        radFastLaneUrl: radFastLaneUrl,
        fixedformUrl: fixedformUrl,
        pathwayNavigatorUrl: pathwayNavigatorUrl,
        imlpToken: imlpToken,
        educatorUserUrl: educatorUserUrl
    };
};
exports.getDefaultParams = getDefaultParams;
